<template lang="html">
  <article class="container mx-auto max-w-3xl px-4 py-8">
    <NuxtLink to="/blog" class="text-sm text-neutral-500 hover:underline">
      ← Все статьи
    </NuxtLink>

    <time v-if="publishedAt" class="mt-6 block text-sm text-neutral-500">
      {{ publishedAt }}
    </time>
    <h1 class="mt-2 mb-6 text-3xl font-semibold">
      {{ item!.title }}
    </h1>

    <ContentTagList :tags="item!.tags" base-path="/blog" class="mb-6" />

    <UiPicture
      v-if="item!.coverId"
      :src="item!.coverId"
      variant="imageFull"
      class="mb-8 aspect-[16/9] w-full overflow-hidden rounded-2xl"
      sizes="100vw md:720px"
      fetchpriority="high"
      :alt="item!.title"
    />

    <ContentBodyRenderer :body-json="item!.bodyJson" />

    <ContentGallery :items="images" />
    <ContentDocuments :items="documents" />
  </article>
</template>

<script setup lang="ts">
import ContentBodyRenderer from '../../components/Body/ContentBodyRenderer.vue'
import ContentTagList from '../../components/ContentTagList.vue'
import ContentDocuments from '../../components/Media/ContentDocuments.vue'
import ContentGallery from '../../components/Media/ContentGallery.vue'
import { useContentMedia } from '../../composables/useContentMedia'

import UiPicture from '~/app/components/Image/UiPicture.vue'

definePageMeta({
  name: 'BlogDetails',
})

const route = useRoute()
const { service } = useContent()
const { formatDate } = useFormatter()

const slug = computed(() => String(route.params.slug))

const { data: item } = await useAsyncData(
  `content-blog-${slug.value}`,
  () => service.getBySlug(slug.value),
  { watch: [slug] },
)

if (!item.value) {
  throw createError({ statusCode: 404, statusMessage: 'Материал не найден' })
}

const publishedAt = computed(() =>
  item.value?.publishAt
    ? formatDate(item.value.publishAt, Formats.DATE_FORMAT)
    : null,
)

const { images, documents } = useContentMedia(item)

useContentSeo(item, {
  article: true,
  breadcrumb: { name: 'Блог', path: '/blog' },
})
</script>
